// search.js
class SearchComponent {
  constructor() {
    this.searchForm = document.querySelector('.Search__Form');
    this.searchInput = document.querySelector('.Search__Input');
    this.resultsContainer = document.querySelector('.Search__Results');
    this.closeButton = document.querySelector('[data-action="close-search"]');
    
    this.initializeEventListeners();
    this.debounceTimeout = null;
    this.currentSearchTerm = '';
  }

  initializeEventListeners() {
    this.searchInput.addEventListener('input', (e) => this.handleInput(e));
    this.searchForm.addEventListener('submit', (e) => this.handleSubmit(e));
    this.closeButton.addEventListener('click', () => this.closeSearch());
  }

  handleInput(event) {
    const searchTerm = event.target.value;
    
    // Clear previous timeout
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // Don't search if term is too short
    if (searchTerm.length < 3) {
      this.resultsContainer.innerHTML = '';
      this.resultsContainer.setAttribute('aria-hidden', 'true');
      return;
    }

    // Debounce search to avoid too many requests
    this.debounceTimeout = setTimeout(() => {
      this.performSearch(searchTerm);
    }, 300);
  }

  async performSearch(searchTerm) {
    if (searchTerm === this.currentSearchTerm) return;
    
    this.currentSearchTerm = searchTerm;
    const url = `/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      this.displayResults(data.resources.results.products);
    } catch (error) {
      console.error('Search error:', error);
      this.resultsContainer.innerHTML = '<p class="Search__Error">An error occurred while searching. Please try again.</p>';
    }
  }

  displayResults(products) {
    if (!products || products.length === 0) {
      this.resultsContainer.innerHTML = '<p class="Search__NoResults">No products found</p>';
      return;
    }

    const resultsHTML = `
      <div class="Search__ResultsInner">
        <div class="Search__ResultsList">
          ${products.map(product => this.generateProductCard(product)).join('')}
        </div>
      </div>
    `;

    this.resultsContainer.innerHTML = resultsHTML;
    this.resultsContainer.setAttribute('aria-hidden', 'false');
  }

  generateProductCard(product) {
    const formattedPrice = this.formatMoney(product.price);
    
    return `
      <a href="${product.url}" class="Search__ResultLink">
        <div class="Search__ResultItem">
          <div class="Search__ResultImage">
            <img src="${product.featured_image.url}" alt="${product.title}" loading="lazy">
          </div>
          <div class="Search__ResultContent">
            <h3 class="Search__ResultTitle">${product.title}</h3>
            <p class="Search__ResultPrice">${formattedPrice}</p>
          </div>
        </div>
      </a>
    `;
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  handleSubmit(event) {
    if (this.searchInput.value.length === 0) {
      event.preventDefault();
    }
  }

  closeSearch() {
    this.searchInput.value = '';
    this.resultsContainer.innerHTML = '';
    this.resultsContainer.setAttribute('aria-hidden', 'true');
    document.querySelector('.Search').setAttribute('aria-hidden', 'true');
  }
}

// Initialize the search component
document.addEventListener('DOMContentLoaded', () => {
  new SearchComponent();
});